import React from 'react';

import { AIChat } from './AIChat';

// The chat state lives in AIChatContextProvider, which each app mounts around
// its routes, so a conversation survives leaving the page and coming back.
export const AITool: React.FC = () => <AIChat />;
